export default {
  viewLive: 'View live camera',
  viewClient: 'View client'
}